import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import {
  batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';
import PropTypes from 'prop-types';

import UserLogCardHeader from '../../../Logs/components/UserLogCardHeader';
import LogDetails from '../../../Logs/components/LogDetails';
import Text from '../../../../components/Text/Text';
import Pagination from '../../../../components/Pagination/Pagination';
import getLogs from '../../../../thunks/logs/getLogs';
import Table from '../../../../components/Table/Table';
import TableHead from '../../../../components/Table/TableHead';
import TableRow from '../../../../components/Table/TableRow';
import TableHeadData from '../../../../components/Table/TableHeadData';
import TableBody from '../../../../components/Table/TableBody';
import EmptyTable from '../../../../components/Table/EmptyTable';
import TableData from '../../../../components/Table/TableData';
import Badge from '../../../../components/Badge/Badge';
import ButtonTypes from '../../../../constants/buttonTypes';
import UserCardSmall from '../../../../components/UserCardSmall/UserCardSmall';
import ActionType from '../../../Logs/components/ActionType';
import LogData from '../../../Logs/components/LogData';
import Card from '../../../../components/Card/Card';
import { resetLogsFilter, setLogsFilter } from '../../../../actions/logs/logsFilter';

const headerTextClassName = 'text-[16px]';

const UserDetailsLog = ({ userId }) => {
  const dispatch = useDispatch();
  const [selectedLog, setSelectedLog] = useState();
  const {
    userLogs: {
      loading, data, currentPage, lastPage
    }
  } = useSelector((state) => ({
    userLogs: state?.getLogs
  }), shallowEqual);

  useEffect(() => {
    batch(() => {
      dispatch(setLogsFilter({ user: userId, size: 3 }));
      dispatch(getLogs());
    });
    return () => {
      dispatch(resetLogsFilter());
    };
  }, [userId]);

  const onPagePress = (page) => {
    batch(() => {
      dispatch(setLogsFilter({ page }));
      dispatch(getLogs());
    });
  };

  return (
    <Card
      showHeader
      headerRight={<UserLogCardHeader showUserFilter={false} />}
      headerLeft={
        <Text text="User Logs" bold textStyle={headerTextClassName} />
      }
      headerBordered={false}
      footer={(
        <div className="d-flex d-justify-end">
          <Pagination
            currentPage={currentPage}
            onPagePress={onPagePress}
            lastPage={lastPage}
          />
        </div>
    )}
      footerBordered={false}
    >
      <div>
        <Table loading={loading}>
          <TableHead>
            <TableRow bordered>
              <TableHeadData>Local time</TableHeadData>
              <TableHeadData>
                user
              </TableHeadData>
              <TableHeadData>
                action
              </TableHeadData>
              <TableHeadData>
                type
              </TableHeadData>
              <TableHeadData>Event</TableHeadData>
              <TableHeadData>Details</TableHeadData>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((log, index) => {
              const {
                action, created_at: date, user, type, data: logData, id
              } = log;
              const name = type?.name || 'Unknown';
              return (
                <TableRow key={id} bordered={index < data.length - 1}>
                  <TableData>
                    <Badge
                      text={DateTime.fromISO(date, { zone: 'utc' }).toLocal()
                    .toFormat('yyyy-MM-dd HH:mm:ss ZZZZ')}
                      type={ButtonTypes.LIGHT}
                    />
                  </TableData>
                  <TableData>
                    <UserCardSmall user={user} />
                  </TableData>
                  <TableData>
                    <ActionType type={action} />
                  </TableData>
                  <TableData>
                    <Badge text={name} type={ButtonTypes.LIGHT} />
                  </TableData>
                  <TableData>
                    <div className="flex justify-start">
                      <LogData logData={logData} type={name} action={action} />
                    </div>
                  </TableData>
                  <TableData>
                    <button
                      type="button"
                      className="px-[9px] py-[6px] rounded bg-primary-light text-primary"
                      onClick={() => setSelectedLog(log)}
                    >
                      View
                    </button>
                  </TableData>
                </TableRow>
              );
            })}
            {!loading && !data?.length && <EmptyTable colSpan={6} text="No logs found" />}
          </TableBody>
        </Table>
        <LogDetails log={selectedLog} onClose={() => setSelectedLog(undefined)} />
      </div>
    </Card>
  );
};

UserDetailsLog.propTypes = {
  userId: PropTypes.number
};

UserDetailsLog.defaultProps = {
  userId: undefined
};

export default UserDetailsLog;
